<template>
    <div>
        <el-table
            v-if="isLoading === false"
            :data="tableData"
            style="width: 100%"
            class="pollen-processing-2-pollen-bottle-table"
            size="mini"
            :header-cell-style="{ background: '#F5F7FA' }"
            border
        >
            <el-table-column
                type="index"
                width="30"
            />
            <el-table-column
                prop="id"
                label="Id"
                min-width="50"
            />
            <el-table-column
                prop="qrCode.code"
                label="QR Code"
                min-width="85"
            />
            <el-table-column
                prop="initialAmount"
                label="Initial Amount (g)"
                min-width="75"
            />
            <el-table-column
                prop="currentAmount"
                label="Current Amount (g)"
                min-width="75"
            />
            <el-table-column
                prop="initialViability"
                label="Initial Viability (%)"
                min-width="75"
            />
            <el-table-column
                prop="currentViability"
                label="Current Viability (%)"
                min-width="75"
            />
        </el-table>
        <p v-else>Loading...</p>
    </div>
</template>

<script>
export default {
    props: {
        pollenBottleList: {
            type: Array
        }
    },
    data() {
        return {
            tableData: [],
            isLoading: false,
        };
    },
    watch: {
        pollenBottleList: {
            immediate: true,
            handler() {
                this.tableData = this.pollenBottleList;
            },
        },
        isLoading() {
            if (this.isLoading === true) {
                this.tableData = [];
            }
        }
    },
    methods: {
    },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Pollen/PollenProcessing2PollenBottleSimpleTable.vue